<template>
    <div class="modal fade" id="createTaskModal" role="dialog" aria-labelledby="createTaskModallLabel"
         aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="createTaskModalLabel">{{ $t('tasks.taskDecline') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="loader" v-if="isSaving"></div>
                <form @submit="submit" v-if="!isSaving">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 form-group">
                                <div class="font-weight-bold">{{ $t('tasks.reason') }}</div>
                                <textarea class="form-control" v-model="reason" name="text"/>
                            </div>
                            <div class="col-md-12 bmd-form-group">
                                <div class="font-weight-bold required">{{ $t('tasks.assignees') }}</div>
                                <CoordinatorsList v-model="assignees"
                                                  :remove-add-btn="assignees.length >= 1"></CoordinatorsList>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="submit" class="btn btn-primary">{{ $t('buttons.save.btnText') }}</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            {{ $t('buttons.cancel') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import taskService from '../../services/tasks.service';
import CoordinatorsList from '../coordinations/coordinators-list';

export default {
    props: {
        show: Boolean,
        taskId: Number,
        currentAssignee: Object
    },
    components: {
        CoordinatorsList
    },
    data() {
        return {
            isSaving: false,
            reason: '',
            assignees: []
        };
    },
    methods: {
        submit(e) {
            e.preventDefault();
            let assignee = this.assignees[0];

            if (!this.hasError) {
                taskService
                    .decline(this.taskId, this.reason, assignee)
                    .then(() => {
                        this.$vs.notify({
                            color: 'success',
                            title: this.$t('updateSuccess'),
                            text: ''
                        });
                        this.$emit('updated');
                    })
                    .catch(err => {
                        this.$vs.notify({
                            color: 'danger',
                            title: this.$t('notifications.error'),
                            text: this.$helpers.errorText(err)
                        });
                    })
                    .then(() => {
                        this.hide();
                    });
            }
        },
        hide() {
            this.reason = '';
            this.assignees = [];
            this.$emit('update:show', false);
            $(this.$el).modal('hide');
        }
    },
    mounted() {
        //add modal close listener
        $(this.$el).on('hidden.bs.modal', this.hide);
    },
    beforeDestroy() {
        //remove listener
        $(this.$el).off('hidden.bs.modal');
    },
    watch: {
        show: function (val) {
            if (val) {
                if (this.currentAssignee) {
                    this.assignees.push(this.currentAssignee);
                }
                $(this.$el).modal('show');
            } else {
                $(this.$el).modal('hide');
            }
        }
    },
    computed: {
        hasError() {
            if (this.assignees.length < 1) {
                return true;
            } else {
                return false;
            }
        }
    }
};
</script>

<style>
</style>
